var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.79,17H1.64C0.74,17,0,16.26,0,15.36V1.64C0,0.74,0.74,0,1.64,0h13.71C16.26,0,17,0.74,17,1.64v9.14 c0,0.13-0.05,0.26-0.15,0.35l-5.71,5.71C11.05,16.95,10.92,17,10.79,17z M1.64,1C1.29,1,1,1.29,1,1.64v13.71 C1,15.71,1.29,16,1.64,16h8.94L16,10.58V1.64C16,1.29,15.71,1,15.36,1H1.64z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.79,17c-0.06,0-0.13-0.01-0.19-0.04c-0.19-0.08-0.31-0.26-0.31-0.46v-4.57c0-0.91,0.74-1.64,1.64-1.64h4.57 c0.2,0,0.38,0.12,0.46,0.31S17,11,16.85,11.14l-5.71,5.71C11.04,16.95,10.92,17,10.79,17z M11.93,11.29 c-0.35,0-0.64,0.29-0.64,0.64v3.36l4.01-4.01H11.93z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.79,
    y: 4.57,
    width: 10.29,
    height: 1,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.79,
    y: 8,
    width: 6.86,
    height: 1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNotes);
export default __webpack_public_path__ + "static/media/IcoNotes.c472aa74fc382d2871b2dca9931d39fa.svg";
export { ForwardRef as ReactComponent };